import React from 'react';
import { useLocale } from '../../context/LocaleContext';

const OfficialBadge: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { locale } = useLocale();
  const label = locale === 'en' ? 'Official' : '官方';
  return (
    <span className={`official-badge ${className}`} title={label}>
      ✓ {label}
    </span>
  );
};

export default OfficialBadge;
